import React from 'react';

import EditIcon from '@mui/icons-material/Edit';
import RemoveIcon from '@mui/icons-material/RemoveCircle';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

import Delete from './Delete';
import Edit from './Edit';

import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { FacilityJson } from '@/types/domain/childApply/entities/facilityEntity';

import ChildInfoComp from '@/domain/child/component/ChildInfo';

/**
 * プロパティ
 */
export type Props = {
  /** 子ども */
  child: ChildJson,
  /** 子ども施設リスト */
  childFacilityList: FacilityJson[],
};

const ChildInfo: React.FC<Props> = ({
  child,
  childFacilityList,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenDelete, setIsOpenDelete] = React.useState(false);
  const disabled = childFacilityList.length > 0;
  return (
    <div>
      <ChildInfoComp
        data={child}
        childFacilityList={childFacilityList}
      />
      <List>
        <ListItem
          button
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <ListItemIcon>
            <EditIcon />
          </ListItemIcon>
          <ListItemText primary="情報の編集" />
        </ListItem>
        <ListItem
          button
          onClick={() => {
            setIsOpenDelete(true);
          }}
          disabled={disabled}
        >
          <ListItemIcon>
            <RemoveIcon />
          </ListItemIcon>
          <ListItemText primary={`登録を解除${disabled ? ' (施設連携を解除してください)' : ''}`} />
        </ListItem>
        {isOpen && <Edit child={child} setIsOpen={setIsOpen} />}
        {isOpenDelete && <Delete child={child} setIsOpen={setIsOpenDelete} />}
      </List>
    </div>
  );
};

export default ChildInfo;
